import React from 'react';
import colors from 'src/style/colors';
import { DottedLineSmall, PlainLineSmall } from '../index';
import { DayTitle, DayText, DayPart, Hours } from '../elements';

/**
 * @type React.FunctionComponent<{ title: string; text?: string, CTA?: string, startHours?: string, endHours?: string, lineStyled?: string}>
 */

const DayTimeSmall = ({ title, text, startHours, endHours, lineStyled }) => {
  return (
    <div
      css={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        alignItems: 'left',
        justifyContent: 'flex-start',
        position: 'relative',
        '&:after': {
          content: '""',
          position: 'absolute',
          width: 15,
          height: 15,
          left: -50,
          top: 0,
          border: `4px solid ${colors.yellow}`,
          backgroundColor: colors.purpleDark,
          borderRadius: '50%',
          zIndex: 1,
        },
      }}
    >
      {lineStyled ? <DottedLineSmall lineStyled={lineStyled} /> : <PlainLineSmall />}
      <Hours>{`${startHours} ${startHours === 'Après' ? '' : '-'} ${endHours}`}</Hours>

      <DayPart>
        <DayTitle>{title}</DayTitle>
        <DayText>{text}</DayText>
      </DayPart>
    </div>
  );
};

export default DayTimeSmall;
